export class EnvironmentVariables {
  public static readonly ApiUrl: string = import.meta.env.VITE_API_URL;
  public static readonly AuthUrl: string = import.meta.env.VITE_AUTH_URL;
  public static readonly PortfolioPortalUrl: string = import.meta.env.VITE_PORTFOLIO_PORTAL_URL;
  public static readonly UpumApplicationName: string =
    import.meta.env.VITE_UPUM_APPLICATION_NAME || 'NHH Contract Portal';
}
